import type { FarmingRecord, PesticideDetail, VideoMonitorInfo, HarvestRecord } from '@trace/shared/types';

export const mockPesticides: PesticideDetail[] = [
  {
    id: 'pest_01',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    landCode: 'LAND-2026-A01',
    name: '0.5% 苦参碱水剂 (植物源生物杀虫剂)',
    inputType: '生物植物源农药',
    standardCode: 'GB/T 19630',
    standard: 'GB/T 19630 有机标准允许使用',
    certNumber: 'OFDC-BIO-2026-088',
    organicCertNo: 'OFDC-BIO-2026-088',
    dosagePerMu: 120,
    unit: 'ml/亩',
    safetyInterval: 7,
    safetyIntervalDays: 7,
    usageDate: '2026-06-15',
    usageTime: '2026-06-15',
    operator: '李春山',
    purpose: '水稻潜叶蝇与负泥虫生物绿色防控',
    remarks: '严格按照安全间隔期（7天）执行',
  },
  {
    id: 'pest_02',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    landCode: 'LAND-2026-A01',
    name: '100亿CFU/克 枯草芽孢杆菌可湿性粉剂',
    inputType: '生物菌剂 / 天敌制剂',
    standardCode: 'GB/T 19630',
    standard: 'GB/T 19630 有机标准允许使用',
    certNumber: 'OFDC-BIO-2026-092',
    organicCertNo: 'OFDC-BIO-2026-092',
    dosagePerMu: 150,
    unit: 'g/亩',
    safetyInterval: 5,
    safetyIntervalDays: 5,
    usageDate: '2026-07-10',
    usageTime: '2026-07-10',
    operator: '李春山',
    purpose: '水稻纹枯病与稻瘟病生物预防',
    remarks: '无人机超低容量喷雾作业',
  },
  {
    id: 'pest_03',
    landId: 'land_02',
    landName: '五常核心有机基地 · 2号稻田B区',
    landCode: 'LAND-2026-A02',
    name: '金龟子绿僵菌 CQMa421 生物制剂',
    inputType: '生物菌剂 / 天敌制剂',
    standardCode: 'GB/T 19630',
    standard: 'GB/T 19630 有机标准允许使用',
    certNumber: 'OFDC-BIO-2026-095',
    organicCertNo: 'OFDC-BIO-2026-095',
    dosagePerMu: 60,
    unit: 'ml/亩',
    safetyInterval: 7,
    safetyIntervalDays: 7,
    usageDate: '2026-07-28',
    usageTime: '2026-07-28',
    operator: '张建军',
    purpose: '稻飞虱与二化螟成虫生物控制',
    remarks: '傍晚喷施，保持孢子萌发湿度',
  },
  {
    id: 'pest_04',
    landId: 'land_03',
    landName: '嫩江平原有机基地 · 3号试验田',
    landCode: 'LAND-2026-B01',
    name: '16000IU/毫克 苏云金杆菌(Bt)生物杀虫悬浮剂',
    inputType: '生物植物源农药',
    standardCode: 'GB/T 19630',
    standard: 'GB/T 19630 有机标准允许使用',
    certNumber: 'OFDC-BIO-2026-103',
    organicCertNo: 'OFDC-BIO-2026-103',
    dosagePerMu: 100,
    unit: 'ml/亩',
    safetyInterval: 10,
    safetyIntervalDays: 10,
    usageDate: '2026-07-30',
    usageTime: '2026-07-30',
    operator: '王志强',
    purpose: '富硒水稻试验田螟虫靶向生物防治',
    remarks: '富硒水稻生长监测期专档',
  },
];

export const mockHarvestRecords: HarvestRecord[] = [
  {
    id: 'hr_01',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    landCode: 'LAND-2026-A01',
    harvestDate: '2026-08-20',
    yieldPerMu: 960, // 960 斤/亩
    area: 120, // 120 亩
    totalYield: 57600, // 57,600 kg (57.6 吨)
    processedWeight: 35000, // 已排产加工 35,000 kg
    moistureContent: 14.2, // 14.2%
    impurityRate: 0.8, // 0.8%
    pureGrainRate: 98.9,
    storageBatchNo: 'PADDY-20260820-001',
    storageBatchNumber: 'PADDY-20260820-001',
    warehouseId: '五常1号恒温智能原粮仓',
    warehouse: '五常1号恒温智能原粮仓',
    operator: '李春山',
    remarks: '洋马联合收割机收割，千粒重28.2g，已入1号恒温通风仓',
    photos: [
      {
        id: 'p_harvest_01',
        url: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=200&auto=format&fit=crop&q=80',
        title: '洋马联合收割机金秋颗粒归仓实景',
        takenAt: '2026-08-20T11:00:00Z',
        operator: '李春山',
        stage: 'harvesting',
        remarks: '千粒重 28.2g，籽粒金黄饱满',
      },
      {
        id: 'p_harvest_02',
        url: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=200&auto=format&fit=crop&q=80',
        title: '原粮入库前水分与杂质率快速抽检',
        takenAt: '2026-08-20T14:30:00Z',
        operator: '王丽娟',
        stage: 'harvesting',
        remarks: '含水率 14.2%，达到安全储粮标准',
      },
    ],
  },
  {
    id: 'hr_02',
    landId: 'land_02',
    landName: '五常核心有机基地 · 2号稻田B区',
    landCode: 'LAND-2026-A02',
    harvestDate: '2026-08-22',
    yieldPerMu: 940, // 940 斤/亩
    area: 150, // 150 亩
    totalYield: 70500, // 70,500 kg (70.5 吨)
    processedWeight: 0, // 待加工
    moistureContent: 14.0,
    impurityRate: 0.7,
    pureGrainRate: 98.5,
    storageBatchNo: 'PADDY-20260822-002',
    storageBatchNumber: 'PADDY-20260822-002',
    warehouseId: '五常2号恒温智能原粮仓',
    warehouse: '五常2号恒温智能原粮仓',
    operator: '张建军',
    remarks: '龙稻18收获入库，气味清香，留存率预计可达86%以上',
    photos: [
      {
        id: 'p_harvest_03',
        url: 'https://images.unsplash.com/photo-1592982537447-7440770cbfc9?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1592982537447-7440770cbfc9?w=200&auto=format&fit=crop&q=80',
        title: '2号稻田机械化收割运输车队',
        takenAt: '2026-08-22T15:00:00Z',
        operator: '张建军',
        stage: 'harvesting',
        remarks: '全流程密闭专用粮食集装箱运输',
      },
    ],
  },
  {
    id: 'hr_03',
    landId: 'land_03',
    landName: '嫩江平原有机基地 · 3号试验田',
    landCode: 'LAND-2026-B01',
    harvestDate: '2026-08-25',
    yieldPerMu: 920, // 920 斤/亩
    area: 90, // 90 亩
    totalYield: 41400, // 41,400 kg (41.4 吨)
    processedWeight: 0, // 待加工
    moistureContent: 13.8,
    impurityRate: 0.6,
    pureGrainRate: 99.1,
    storageBatchNo: 'PADDY-20260825-003',
    storageBatchNumber: 'PADDY-20260825-003',
    warehouseId: '嫩江1号富硒原粮专储仓',
    warehouse: '嫩江1号富硒原粮专储仓',
    operator: '王志强',
    remarks: '富硒水稻专品专储，硒含量实测 0.045 mg/100g 达富硒高标',
    photos: [
      {
        id: 'p_harvest_04',
        url: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=200&auto=format&fit=crop&q=80',
        title: '嫩江试验田富硒穗粒样品采集',
        takenAt: '2026-08-25T11:00:00Z',
        operator: '王志强',
        stage: 'harvesting',
        remarks: '穗长均匀，结实率高达92%',
      },
    ],
  },
];

export const mockFarmingRecords: FarmingRecord[] = [
  {
    id: 'farm_01',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    stage: 'seeding',
    stageName: '阶段 1 · 浸种催芽 / 恒温育苗',
    operationDate: '2026-04-18T08:30:00Z',
    operator: '李春山',
    temperature: 18.5,
    humidity: 65,
    weather: '晴天微风',
    workDescription: '采用智能温控育苗大棚进行弱碱性自流活水浸种催芽，机械精准播种覆土，培育齐苗壮秧。',
    pesticides: [],
    fertilizers: [
      {
        id: 'fert_01',
        name: '生物腐殖酸育苗基质专用有机肥',
        dosagePerMu: 80,
        usageTime: '2026-04-18T08:30:00Z',
        operator: '李春山',
      },
    ],
    photos: [
      {
        id: 'p_01',
        url: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=200&auto=format&fit=crop&q=80',
        title: '智能恒温育苗大棚浸种催芽实景',
        takenAt: '2026-04-18T10:00:00Z',
        operator: '李春山',
        stage: 'seeding',
        remarks: '出苗率达到98.5%，秧苗根系粗壮',
      },
    ],
    createdAt: '2026-04-18T12:00:00Z',
    updatedAt: '2026-04-18T12:00:00Z',
  },
  {
    id: 'farm_02',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    stage: 'transplanting',
    stageName: '阶段 2 · 北斗高精无人插秧',
    operationDate: '2026-05-20T07:00:00Z',
    operator: '李春山',
    temperature: 22.0,
    humidity: 70,
    weather: '多云',
    workDescription: '水田平整沉实达标后，采用久保田高速插秧机精准密植，株距14cm，行距30cm，引入拉林河活水护苗。',
    pesticides: [],
    fertilizers: [
      {
        id: 'fert_02',
        name: '充分腐熟纯羊粪发酵有机基肥',
        dosagePerMu: 500,
        usageTime: '2026-05-18T10:00:00Z',
        operator: '张建军',
      },
    ],
    photos: [
      {
        id: 'p_02',
        url: 'https://images.unsplash.com/photo-1592982537447-7440770cbfc9?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1592982537447-7440770cbfc9?w=200&auto=format&fit=crop&q=80',
        title: '高速精准密植机械插秧作业现场',
        takenAt: '2026-05-20T09:00:00Z',
        operator: '李春山',
        stage: 'transplanting',
        remarks: '插秧密度24穴/㎡，活棵返青迅速',
      },
    ],
    createdAt: '2026-05-20T12:00:00Z',
    updatedAt: '2026-05-20T12:00:00Z',
  },
  {
    id: 'farm_03',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    stage: 'growing',
    stageName: '阶段 3 · 稻鸭共育田管 / 生物防控',
    operationDate: '2026-07-15T09:00:00Z',
    operator: '赵铁柱',
    temperature: 28.5,
    humidity: 80,
    weather: '晴天',
    workDescription: '田间分蘖拔节期管理。投放稻田鸭进行除草除虫，配合太阳能频振式杀虫灯与生物苦参碱喷施防控。',
    pesticides: [mockPesticides[0]!, mockPesticides[1]!],
    fertilizers: [
      {
        id: 'fert_03',
        name: '豆粕发酵生物氨基酸水溶追肥',
        dosagePerMu: 15,
        usageTime: '2026-07-12T14:00:00Z',
        operator: '李春山',
      },
    ],
    photos: [
      {
        id: 'p_03',
        url: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=200&auto=format&fit=crop&q=80',
        title: '稻鸭共育生态除草与田间巡查实拍',
        takenAt: '2026-07-15T10:30:00Z',
        operator: '赵铁柱',
        stage: 'growing',
        remarks: '水稻长势旺盛，叶色浓绿，无病虫害迹象',
      },
    ],
    createdAt: '2026-07-15T12:00:00Z',
    updatedAt: '2026-07-15T12:00:00Z',
  },
  {
    id: 'farm_04',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    stage: 'harvesting',
    stageName: '阶段 4 · 金秋收割适期测产',
    operationDate: '2026-08-20T08:00:00Z',
    operator: '李春山',
    temperature: 24.0,
    humidity: 58,
    weather: '秋高气爽',
    workDescription: '稻穗95%黄熟适期收割。使用洋马水稻联合收割机收割脱粒，测产登记并建立原粮批次档案。',
    pesticides: [],
    fertilizers: [],
    harvestRecord: {
      id: 'hr_embedded_01',
      landId: 'land_01',
      landName: '五常核心有机基地 · 1号稻田A区',
      landCode: 'LAND-2026-A01',
      harvestDate: '2026-08-20T17:00:00Z',
      yieldPerMu: 960, // 960斤/亩
      area: 120, // 120亩
      totalYield: 57600, // 120亩 * 960斤 / 2 = 57,600 kg
      processedWeight: 35000,
      moistureContent: 14.2, // 14.2%
      impurityRate: 0.8, // 0.8%
      storageBatchNumber: 'PADDY-20260820-001',
      photos: [
        {
          id: 'p_04',
          url: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=600&auto=format&fit=crop&q=80',
          thumbnailUrl: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=200&auto=format&fit=crop&q=80',
          title: '联合收割机金秋颗粒归仓实景',
          takenAt: '2026-08-20T11:00:00Z',
          operator: '李春山',
          stage: 'harvesting',
          remarks: '千粒重28.2g，籽粒饱满，稻香浓郁',
        },
      ],
      operator: '李春山',
      remarks: '原粮直接密闭运往恒温通风仓入库',
    },
    photos: [
      {
        id: 'p_04',
        url: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=600&auto=format&fit=crop&q=80',
        thumbnailUrl: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=200&auto=format&fit=crop&q=80',
        title: '联合收割机金秋颗粒归仓实景',
        takenAt: '2026-08-20T11:00:00Z',
        operator: '李春山',
        stage: 'harvesting',
        remarks: '千粒重28.2g，籽粒饱满，稻香浓郁',
      },
    ],
    createdAt: '2026-08-20T18:00:00Z',
    updatedAt: '2026-08-20T18:00:00Z',
  },
];

export const mockVideoMonitors: VideoMonitorInfo[] = [
  {
    id: 'cam_01',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    deviceName: '海康威视4K全景星光球机 #01 (东向全景)',
    streamUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    isOnline: true,
    lastUpdated: '2026-08-26T17:00:00Z',
    recordedClips: [
      {
        id: 'clip_01',
        title: '8月20日 联合收割作业全景回放',
        duration: 3600,
        coverUrl: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=400&auto=format&fit=crop&q=80',
        videoUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
        recordedAt: '2026-08-20T08:00:00Z',
      },
      {
        id: 'clip_02',
        title: '7月15日 稻鸭共育生态巡田实录',
        duration: 1800,
        coverUrl: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=400&auto=format&fit=crop&q=80',
        videoUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
        recordedAt: '2026-07-15T09:00:00Z',
      },
    ],
  },
  {
    id: 'cam_02',
    landId: 'land_02',
    landName: '五常核心有机基地 · 2号稻田B区',
    deviceName: '海康威视气象联动枪机 #02 (高空俯瞰)',
    streamUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    isOnline: true,
    lastUpdated: '2026-08-26T17:00:00Z',
    recordedClips: [],
  },
  {
    id: 'cam_03',
    landId: 'land_03',
    landName: '嫩江平原有机基地 · 3号试验田',
    deviceName: '大华低照度AI物联监控 #03',
    streamUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    isOnline: false,
    lastUpdated: '2026-08-25T16:00:00Z',
    recordedClips: [],
  },
];
